// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3x08r","empty":"ModalGraph_empty__qFLyh"};